import {
  Box,
  ChakraProvider,
} from "@chakra-ui/react"
import theme from "./ColorModeScript"
import Navbar from "./client/components/Navbar"
import { Route, Routes } from "react-router-dom"
import Home from "./client/pages/Home"
import LandingPage from "./client/pages/LandingPage"
import { HOME, MISC, PRESTUDY_SPLITTER } from "./client/constants/Routes"
import NotFound from "./client/pages/NotFound"
import Footer from "./client/components/Footer"
import PrestudyComponent from "./client/pages/wrappers/PrestudyComponent"

export const App = () => (
  <ChakraProvider theme={theme}>
    <Navbar />
    <Routes>
      <Route path="/" Component={LandingPage} />
      <Route path={HOME} Component={Home} />
      <Route path={MISC + PRESTUDY_SPLITTER} Component={PrestudyComponent} />
      <Route path="*" Component={NotFound} />
    </Routes>
    <Box height={"10vh"} />
    <Footer />
  </ChakraProvider>
)
